var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.26644L4 2.80644M1.18 4.63977L7 8.00644L12.82 4.63977M7 14.7198V7.99977M13 10.6664V5.33311C12.9998 5.09929 12.938 4.86965 12.821 4.66721C12.704 4.46478 12.5358 4.29668 12.3333 4.17977L7.66667 1.51311C7.46397 1.39608 7.23405 1.33447 7 1.33447C6.76595 1.33447 6.53603 1.39608 6.33333 1.51311L1.66667 4.17977C1.46417 4.29668 1.29599 4.46478 1.17897 4.66721C1.06196 4.86965 1.00024 5.09929 1 5.33311V10.6664C1.00024 10.9003 1.06196 11.1299 1.17897 11.3323C1.29599 11.5348 1.46417 11.7029 1.66667 11.8198L6.33333 14.4864C6.53603 14.6035 6.76595 14.6651 7 14.6651C7.23405 14.6651 7.46397 14.6035 7.66667 14.4864L12.3333 11.8198C12.5358 11.7029 12.704 11.5348 12.821 11.3323C12.938 11.1299 12.9998 10.9003 13 10.6664Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/Package.4aaef37afb67e5f74cd10e19d091e5a9.svg";
export { ForwardRef as ReactComponent };